<div class="save-report-as-dialog" data-testid="save-report-as-dialog">
  <p class="save-report-as-hint">{{ 'reports.saveAsDialog.hint' | translate }}</p>
  <formly-form [form]="form" [fields]="fields" [model]="model" (modelChange)="onModelChange($event)"
    data-testid="save-report-as-form" />
</div>
